import { GeneralPageError } from "@/components/Errors/GeneralPageError";
import { OfferNotAvailableError } from "@/components/Errors/OfferNotAvailableError";
import { isOfferIsNotAvailableAnymoreError } from "@/utils/assertions";

interface HotelOfferErrorProps {
  error: unknown;
}

export const HotelOfferError = ({ error }: HotelOfferErrorProps) => {
  if (error && isOfferIsNotAvailableAnymoreError(error)) {
    return <OfferNotAvailableError variant="hotel" />;
  }
  return (
    <GeneralPageError
      backOptions={{ to: "/", search: { category: "hotels" } }}
    />
  );
};
